// Yumi PDP — append a price span to the Add-to-cart button (NEVER wipes innerHTML)
(function () {
  if (!document.body.classList.contains('template-product')) return;

  function getPriceText() {
    var el =
      document.querySelector('.product-single__price .money') ||
      document.querySelector('.product-single__price') ||
      document.querySelector('.price-item--regular .money') ||
      document.querySelector('.price-item--regular') ||
      document.querySelector('.product__price .money') ||
      document.querySelector('.product__price');
    return el ? el.textContent.trim() : '';
  }

  function getCartBtns() {
    return document.querySelectorAll('.product-form__cart-submit, button[name="add"]');
  }

  function injectOrUpdate() {
    var price = getPriceText();
    getCartBtns().forEach(function (btn) {
      var tag = btn.querySelector('.yumi-price-tag');
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'yumi-price-tag';
        btn.appendChild(tag);
      }
      tag.textContent = price;
    });
  }

  document.addEventListener('DOMContentLoaded', injectOrUpdate);
  document.addEventListener('change', function (e) {
    if (e.target.closest('form[action*="/cart/add"]')) setTimeout(injectOrUpdate, 60);
  });
  if (window.jQuery) jQuery(document).on('variantChange', injectOrUpdate);
  injectOrUpdate();
  setTimeout(injectOrUpdate, 600);
  setTimeout(injectOrUpdate, 1500);
})();
